import { Box } from "@chakra-ui/react";
import { Outlet } from "react-router-dom";
import BgImage from "@/assets/bg.png";
import { UserInfoProvider } from "./context/UserInfo";
import "swiper/css";

const App = () => {
  return (
    <Box
      sx={{
        height: "100%",
        backgroundImage: `url(${BgImage})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
      }}
    >
      <UserInfoProvider>
        <Outlet />
      </UserInfoProvider>
    </Box>
  );
};

export default App;
